<template>
  <template v-if="type == 'horizontal'">
    <li
      ref="menuItem"
      @mouseover="showChildren"
      @mouseleave="hideChildren"
      @click="handleItemClick"
      :class="{ active: isActivePage === itemKey || showChild }"
    >
      <router-link v-if="!hasChildren(item)" :to="itemOrgKey" class="">
        <div class="sideNav-list">
          <template v-if="itemKey == 'home'"
            ><font-awesome-icon style="width: 25px" :icon="['fas', 'home']" />
          </template>
          {{ item.name }}
        </div>
      </router-link>
      <div v-if="hasChildren(item)" class="sideNav-list">
        <template v-if="itemKey == 'home'"
          ><font-awesome-icon style="width: 25px" :icon="['fas', 'home']" />
        </template>
        {{ item.name }}
      </div>
    </li>
    <div
      v-if="showChild && hasChildren(item)"
      @mouseover="showChildren"
      @mouseleave="hideChildren"
      class="px-0 main-background-color sideNav-active"
      style="position: absolute; width: 200px; z-index: 10"
      :style="{
        top: submenuPosition.top + 'px',
        left: submenuPosition.left + 'px',
      }"
    >
      <ul style="position: relative; padding: 0px">
        <template v-if="hasChildren(item)">
          <sidebarItem
            v-for="(childItem, childKey) in item.children"
            :key="childKey"
            :item="childItem"
            :itemKey="childKey"
            :path="[...path, childKey]"
            :itemOrgKey="itemOrgKey"
            :type="type"
            :topPos="topPosCtrl"
          />
        </template>
      </ul>
    </div>
  </template>
  <template v-else-if="type == 'vertical'">
    <li
      class="text-start"
      @click="handleItemClick(), showChildren()"
      :style="{ background: colorArray[deep] }"
    >
      <router-link v-if="!hasChildren(item)" :to="itemOrgKey" class="">
        <div class="sideNav-list">
          <template v-if="itemKey == 'home'"
            ><font-awesome-icon style="width: 25px" :icon="['fas', 'home']" />
          </template>
          <template v-else-if="itemKey == 'elecboard'"
            ><font-awesome-icon
              style="width: 25px"
              :icon="['fas', 'display']"
            />
          </template>
          <template v-else-if="itemKey == 'activation'"
            ><font-awesome-icon
              style="width: 25px"
              :icon="['fas', 'chart-line']"
            />
          </template>
          <template v-else-if="itemKey == 'operatelog'"
            ><font-awesome-icon style="width: 25px" :icon="['fas', 'cogs']" />
          </template>
          <template v-else-if="itemKey == 'alarmhistory'"
            ><font-awesome-icon
              style="width: 25px"
              :icon="['fas', 'exclamation-triangle']"
            />
          </template>
          <template v-else-if="itemKey == 'workorderhistory'"
            ><font-awesome-icon style="width: 25px" :icon="['fas', 'file']" />
          </template>
          <template v-else-if="itemKey == 'devicemanagement'"
            ><font-awesome-icon
              style="width: 25px"
              :icon="['fas', 'vector-square']"
            />
          </template>
          {{ item.name }}
        </div>
      </router-link>
      <div v-if="hasChildren(item)" class="sideNav-list">
        <template v-if="itemKey == 'home'"
          ><font-awesome-icon style="width: 25px" :icon="['fas', 'home']" />
        </template>
        <template v-else-if="itemKey == 'elecboard'"
          ><font-awesome-icon style="width: 25px" :icon="['fas', 'display']" />
        </template>
        <template v-else-if="itemKey == 'activation'"
          ><font-awesome-icon
            style="width: 25px"
            :icon="['fas', 'chart-line']"
          />
        </template>
        <template v-else-if="itemKey == 'operatelog'"
          ><font-awesome-icon style="width: 25px" :icon="['fas', 'cogs']" />
        </template>
        <template v-else-if="itemKey == 'alarmhistory'"
          ><font-awesome-icon
            style="width: 25px"
            :icon="['fas', 'exclamation-triangle']"
          />
        </template>
        <template v-else-if="itemKey == 'workorderhistory'"
          ><font-awesome-icon style="width: 25px" :icon="['fas', 'file']" />
        </template>
        <template v-else-if="itemKey == 'devicemanagement'"
          ><font-awesome-icon
            style="width: 25px"
            :icon="['fas', 'vector-square']"
          />
        </template>
        {{ item.name }}
      </div>
    </li>
    <ul v-if="showChild" class="px-0 text-start" style="text-indent: 1.4em">
      <template v-if="hasChildren(item)">
        <sidebarItem
          v-for="(childItem, childKey) in item.children"
          :key="childKey"
          :item="childItem"
          :itemKey="childKey"
          :path="[...path, childKey]"
          :itemOrgKey="itemOrgKey"
          :type="type"
          :colorArray="colorArray"
          :deep="deep + 1"
        />
      </template>
    </ul>
  </template>
</template>

<script>
import { inject, ref, watch } from "vue";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    itemKey: {
      type: String,
    },
    itemOrgKey: {
      type: String,
      required: true,
    },
    path: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: "horizontal",
      required: true,
    },
    colorArray: {
      type: Array,
      default: [],
    },
    deep: {
      type: Number,
      default: 0,
    },
    topPos: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const showChild = ref(false);
    const submenuPosition = ref({ top: 0, left: 0 });
    const menuItem = ref(null); // 用於存儲 li 元素的 ref
    const topPosCtrl = props.topPos + 1;
    const sideNavTrigger = inject("sideNavTrigger");
    const allChildHide = inject("allChildHide");
    const isActivePage = inject("isActivePage");
    const sideNavPath = inject("sideNavPath"); // 用於儲存已執行的資料
    let hideTimeout;

    const showChildren = () => {
      clearTimeout(hideTimeout); // 停止隱藏計時器
      if (menuItem.value) {
        // 使用 getBoundingClientRect 獲取 li 元素的位置
        const rect = menuItem.value.getBoundingClientRect();
        submenuPosition.value = {
          top: rect.y - 60 * topPosCtrl, // 子選單顯示在 li 元素下方
          left: rect.width, // 子選單顯示在 li 元素右側
        };
      }
      if (hasChildren(props.item)) {
        showChild.value = true;
      }
      if (props.type === "vertical") {
        if (!hasChildren(props.item)) {
          allChildHide.value = Math.random();
          sideNavTrigger.value = false;
        }
      }
    };

    const hideChildren = () => {
      if (hasChildren(props.item)) {
        hideTimeout = setTimeout(() => {
          showChild.value = false; // 隱藏子選單
        }, 0); // 延遲一點隱藏以便滑鼠移動
      }
    };

    const hasChildren = (item) => {
      return item && item.children && Object.keys(item.children).length > 0;
    };

    const handleItemClick = () => {
      if (props.type === "horizontal") {
        if (!hasChildren(props.item)) {
          hideChildren();
          sideNavPath.value = props.path;
          isActivePage.value = props.itemOrgKey;
          allChildHide.value = Math.random();
          if (props.itemOrgKey === "elecboard") {
            sideNavTrigger.value = false;
          }
        }
      }
      if (props.type === "vertical") {
        if (!hasChildren(props.item)) {
          sideNavPath.value = props.path;
        }
        isActivePage.value = props.itemOrgKey;
      }
    };

    watch(allChildHide, () => {
      hideChildren();
    });

    watch(isActivePage, (newValue) => {
      if (props.type === "vertical") {
        if (newValue != props.itemOrgKey) {
          hideChildren();
        }
      }
    });

    return {
      showChild,
      submenuPosition,
      menuItem,
      topPosCtrl,
      isActivePage,
      showChildren,
      hideChildren,
      hasChildren,
      handleItemClick,
    };
  },
};
</script>

<style>
/* Add your styles here */
</style>
